import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { PatientChipComponent } from './patient-chip/patient-chip.component';
import { SelfCareChipComponent } from './self-care-chip/self-care-chip.component';
import { PatientProviderCellComponent } from './patient-provider-cell/patient-provider-cell.component';

@NgModule({
    declarations: [PatientChipComponent, SelfCareChipComponent, PatientProviderCellComponent],
    imports: [CommonModule, PipesModule],
    exports: [PatientChipComponent, SelfCareChipComponent, PatientProviderCellComponent],
})
export class ChipsModule {}
